import { useTranslation } from 'next-i18next'
import { useTheme } from 'styled-components'

import { ImageBadgeIcons } from '@/components/srp/listing-card/listing-image-badge/ListingImageBadge'
import { TRANSLATION_KEYS } from '@/constants/localization'
import { getListingBadgeLabel } from '@/domain/listings/getListingBadgeLabel'
import { AdTypeBadge } from '@/features/listing/components/rich-card/styled'
import { type GenericListing } from '@/features/listing/types/listings'
import { BadgeSize } from '@/ui/atoms/badge/Badge'
import { hexToRgb } from '@/ui/helpers/hexToRgb'

export const RichCardBadges = ({ listing }: { listing: GenericListing }) => {
  const { t } = useTranslation([TRANSLATION_KEYS.LISTING])
  const { colors } = useTheme()

  const flags = 'flags' in listing ? listing.flags : undefined
  const isTopAd = !!flags?.topAd

  const { categoryId } = listing

  const imageBadge = getListingBadgeLabel({
    categorySpecificBadge: flags?.categorySpecificBadge ?? false,
    categoryId,
  })

  if (!imageBadge && !isTopAd) {
    return null
  }

  const badgeProps = {
    size: BadgeSize.LARGE,
    backgroundColor: hexToRgb(colors.grey.primary, 0.7),
    color: colors.white,
    isBorderless: true,
  }

  if (imageBadge) {
    return (
      <AdTypeBadge
        {...badgeProps}
        leftIcon={<>{ImageBadgeIcons[imageBadge]}</>}
        label={t(`listing:badges.${imageBadge}`)}
      />
    )
  }

  if (isTopAd) {
    return <AdTypeBadge {...badgeProps} label={t('listing:sponsored')} />
  }

  return null
}
